import dynamic from 'next/dynamic';
const ImageTextSecondaryWIthSlideAnimation = dynamic(
  () => import('./ImageTextSecondaryWIthSlideAnimation')
);
export default ImageTextSecondaryWIthSlideAnimation;
